import {Sprite, Text} from 'pixi.js';
import {CoreDI, CurrencyFormatter, DeviceType, Easing, inject, LanguageService, Meter, Timer} from '@gongxigames/framework/core';
import {IWinMeter} from '@gongxigames/framework/slot/modules/winmeter/index';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad';
import {View} from '@gongxigames/framework/slot/fragments/module/view';

export class WinMeterView extends View implements IWinMeter {
    public static readonly NAME: symbol = Symbol('WinMeterView');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.DESKTOP;

    protected static readonly SHOWING_FINAL_VALUE_DELAY: number = 500;

    @inject(CoreDI.CurrencyFormatter)
    protected _currencyFormatter!: CurrencyFormatter;

    @inject(CoreDI.LanguageService)
    protected _languageService!: LanguageService;

    protected _meter!: Meter;
    protected _finalValueShowTimer?: Timer;

    public init(): void {
        // super.setParameters();

        this.initGraphicElements();
    }

    protected initGraphicElements(): void {
        this.winField = (this.mainSprite.getChildByName<Sprite>('winPanel')).getChildByName<Text>('fieldText');
        this.winLabel = (this.mainSprite.getChildByName<Sprite>('winPanel')).getChildByName<Text>('label');
    }

    public hideWinMeter(): void {
        this._meter.set(0);
        this._meter.textObject.visible = false;
    }

    public setValue(value: number, setIfPlaying: boolean): void {
        if (setIfPlaying) {
            if (this._meter.isPlaying) {
                this._meter.set(value);
                this._meter.textObject.visible = true;
            }
        } else {
            this._meter.set(value);
            this._meter.textObject.visible = true;
        }
    }

    public countUp(from: number, to: number, duration: number, callback: Function): void {
        this._meter.textObject.visible = true;
        this._meter.onCompleteCallback = callback;
        this._meter.from(from).to(to, duration);
    }

    public stopAfterShowingFinalValue(value: number, clearMeterAfterPause: boolean): void {
        if (this._meter.isPlaying) {
            this._meter.set(value);
            this.stopFinalValueTimer();

            if (!clearMeterAfterPause) {
                this._finalValueShowTimer = new Timer(this.hideWinMeter.bind(this), WinMeterView.SHOWING_FINAL_VALUE_DELAY, true);
                this.updateManager.add(this._finalValueShowTimer);
            }
        } else {
            this.hideWinMeter();
        }
    }

    public stopFinalValueTimer(): void {
        if (this._finalValueShowTimer) {
            this.updateManager.remove(this._finalValueShowTimer);
            this._finalValueShowTimer.stop();
            delete this._finalValueShowTimer;
        }
    }

    public snapToFinalValue(): void {
        this._meter.snapToFinalValue();
    }

    public setValueIfPlaying(value: number): void {
        if (this._meter.isPlaying) {
            this._meter.set(value);
        }
    }

    public set winField(value: Text) {
        if (this._meter) {
            this._meter.stop();
        }

        this._meter = new Meter(value, Easing.Linear.None, this._currencyFormatter);

        this._meter.start();
        this._meter.textObject.visible = false;
        this.updateManager.add(this._meter);
    }

    public set winLabel(value: Text) {
        value.text = this._languageService.get('winLabel');
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadView.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadView.NAME];
    }
}
